<device-history>
  <div class="mt-5">
    <h4 class="mb-3">Historial del dispositivo</h4>

    <div class="card mb-4">
      <div class="card-header bg-light">
        <h5 class="mb-0">Últimas actividades</h5>

        <!-- Filters for history -->
        <div class="mt-3">
          <div class="row g-2">
            <div class="col-12 col-md-3">
              <label class="form-label small mb-1">Tipo</label>
              <select class="form-select form-select-sm" value={ state.historyFilters.type } onchange={ (e)=>
                handleHistoryFilterChange('type', e.target.value) }
                >
                <option value="">Todos los tipos</option>
                <option value="state">Estados</option>
                <option value="cmd">Comandos</option>
                <option value="data">Datos</option>
                <option value="info">Información</option>
                <option value="cfg">Configuración</option>
                <option value="error">Errores</option>
              </select>
            </div>

            <div class="col-12 col-md-3">
              <label class="form-label small mb-1">Canal/Acción</label>
              <select class="form-select form-select-sm" value={ state.historyFilters.action } onchange={ (e)=>
                handleHistoryFilterChange('action', e.target.value) }
                >
                <option value="">Todos los canales</option>
                <!-- Añadir opciones basadas en los canales disponibles del dispositivo -->
                <option each={ channel in props.deviceChannels } value={ channel.channel }>
                  { channel.name } ({ channel.channel })
                </option>
                <!-- Opciones adicionales comunes de acciones/eventos que no son canales -->
                <option value="chip_id">Chip ID</option>
                <option value="power_in">Alimentación</option>
                <option value="reset">Reinicio</option>
              </select>
            </div>

            <div class="col-12 col-md-2">
              <label class="form-label small mb-1">Desde</label>
              <input type="datetime-local" class="form-control form-control-sm" value={
                formatDateForInput(state.historyFilters.startDate) } onchange={ (e)=>
              handleDateFilterChange('startDate', e.target.value) }
              />
            </div>

            <div class="col-12 col-md-2">
              <label class="form-label small mb-1">Hasta</label>
              <input type="datetime-local" class="form-control form-control-sm" value={
                formatDateForInput(state.historyFilters.endDate) } onchange={ (e)=> handleDateFilterChange('endDate',
              e.target.value) }
              />
            </div>

            <div class="col-12 col-md-2 d-flex align-items-end">
              <button class="btn btn-sm btn-primary w-100" onclick={ loadDeviceHistory } disabled={ state.historyLoading
                }>
                <i class="bi bi-arrow-repeat me-1"></i>
                { state.historyLoading ? 'Cargando...' : 'Actualizar' }
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body">
        <!-- Loading spinner for history -->
        <div if={ state.historyLoading } class="text-center my-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <p class="mt-2">Cargando historial...</p>
        </div>

        <!-- History error message -->
        <div if={ state.historyError } class="alert alert-danger">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          Error al cargar el historial: { state.historyErrorMessage }
          <button type="button" class="btn btn-sm btn-outline-danger ms-3" onclick={ loadDeviceHistory }>
            <i class="bi bi-arrow-repeat me-1"></i> Reintentar
          </button>
        </div>

        <!-- History table -->
        <div if={ !state.historyLoading && !state.historyError && state.history && state.history.data }>
          <div class="table-responsive">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Tipo</th>
                  <th>Acción</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr each={ entry in state.history.data }>
                  <td>{ formatDate(entry.date) }</td>
                  <td>
                    <span class="badge bg-{ getHistoryTypeBadge(entry.type) }">
                      { translateHistoryType(entry.type) }
                    </span>
                  </td>
                  <td>{ entry.action }</td>
                  <td>{ entry.value }</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div if={ state.history.meta } class="d-flex justify-content-between align-items-center mt-3">
            <div class="d-flex align-items-center gap-2">
              <small class="text-muted">
                Mostrando { state.history.data.length } de { state.history.meta.total } registros
              </small>
              <select class="form-select form-select-sm ms-2" style="width: auto;" onchange={ (e)=>
                handleLimitChange(parseInt(e.target.value)) }
                value={ state.historyFilters.limit }
                >
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </select>
            </div>
            <div class="d-flex gap-2">
              <button class="btn btn-sm btn-outline-primary" onclick={ ()=> loadMoreHistory('prev') }
                disabled={ state.historyFilters.skip <= 0 }>
                  <i class="bi bi-chevron-left"></i> Anterior
              </button>
              <span class="d-flex align-items-center px-3 border rounded bg-light">
                Página { Math.floor(state.historyFilters.skip / state.historyFilters.limit) + 1 }
                de { Math.ceil(state.history.meta.total / state.historyFilters.limit) }
              </span>
              <button class="btn btn-sm btn-outline-primary" onclick={ ()=> loadMoreHistory('next') }
                disabled={ (state.historyFilters.skip + state.history.data.length) >= state.history.meta.total }
                >
                Siguiente <i class="bi bi-chevron-right"></i>
              </button>
            </div>
          </div>

          <!-- No results message -->
          <div if={ state.history.data && state.history.data.length===0 } class="text-center py-4 text-muted">
            <i class="bi bi-inbox-fill mb-2" style="font-size: 2rem;"></i>
            <p>No hay registros de historial que coincidan con los filtros seleccionados.</p>
          </div>
        </div>
      </div>
    </div>

  </div>

  <script>
    import { DeviceService } from '../services';

    export default {
      props: {
        deviceId: String,
        deviceChannels: { type: Array, default: () => [] } // Recibe los canales del dispositivo
      },

      state: {
        history: null,
        historyLoading: false,
        historyError: false,
        historyErrorMessage: '',
        historyFilters: {
          type: '',
          action: '',
          limit: 10,
          skip: 0,
          startDate: null,
          endDate: null
        },
      },

      onMounted() {
        this.loadDeviceHistory();
      },

      async loadDeviceHistory() {
        if (!this.props.deviceId) return;

        this.update({
          historyLoading: true,
          historyError: false,
          historyErrorMessage: ''
        });

        try {
          const history = await DeviceService.getDeviceHistory(
            this.props.deviceId,
            this.state.historyFilters
          );

          this.update({
            history,
            historyLoading: false
          });
        } catch (error) {
          console.error('Error al cargar historial:', error);
          this.update({
            historyLoading: false,
            historyError: true,
            historyErrorMessage: error.message || 'Error desconocido'
          });
        }
      },

      handleHistoryFilterChange(filterName, value) {
        const newFilters = {
          ...this.state.historyFilters,
          [filterName]: value,
          skip: 0 // Resetear paginación al cambiar filtro
        };

        this.update({
          historyFilters: newFilters
        });

        // Cargar historial con los nuevos filtros
        this.loadDeviceHistory();
      },

      handleDateFilterChange(filterName, value) {
        let timestamp = null;
        if (value) {
          try {
            const date = new Date(value);
            timestamp = date.getTime();
          } catch (e) {
            console.warn("Invalid date input", value);
            timestamp = null; // Mantener null si la fecha no es válida
          }
        }

        const newFilters = {
          ...this.state.historyFilters,
          [filterName]: timestamp,
          skip: 0 // Resetear paginación al cambiar filtro
        };

        this.update({
          historyFilters: newFilters
        });

        // Cargar historial con los nuevos filtros
        this.loadDeviceHistory();
      },

      handleLimitChange(newLimit) {
        if (newLimit && newLimit > 0 && newLimit <= 100) {
          const newFilters = {
            ...this.state.historyFilters,
            limit: newLimit,
            skip: 0 // Resetear paginación al cambiar límite
          };

          this.update({
            historyFilters: newFilters
          });

          // Cargar historial con el nuevo límite
          this.loadDeviceHistory();
        }
      },

      loadMoreHistory(direction) {
        const currentSkip = this.state.historyFilters.skip;
        const limit = this.state.historyFilters.limit;
        const total = this.state.history?.meta?.total || 0;

        let newSkip = currentSkip;
        if (direction === 'next') {
          newSkip = currentSkip + limit;
          // Evitar ir más allá del total
          if (newSkip >= total) {
            return; // Ya estamos en la última página o más allá
          }
        } else if (direction === 'prev') {
          newSkip = Math.max(0, currentSkip - limit);
        }

        // Solo actualizar y cargar si el skip realmente cambió
        if (newSkip !== currentSkip) {
          this.update({
            historyFilters: {
              ...this.state.historyFilters,
              skip: newSkip
            }
          });
          this.loadDeviceHistory();
        }
      },

      // --- Helper Functions ---

      formatDate(timestamp) {
        if (!timestamp) return 'Fecha desconocida';
        try {
          const date = new Date(timestamp);
          return new Intl.DateTimeFormat('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          }).format(date);
        } catch (e) {
          console.error("Error formatting date:", timestamp, e);
          return 'Fecha inválida';
        }
      },

      formatDateForInput(timestamp) {
        if (!timestamp) return '';
        try {
          const date = new Date(timestamp);
          // Ajustar a la zona horaria local para el input datetime-local
          const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
          return localDate.toISOString().slice(0, 16);
        } catch (e) {
          console.error("Error formatting date for input:", timestamp, e);
          return '';
        }
      },

      getHistoryTypeBadge(type) {
        switch (type) {
          case 'state': return 'success';
          case 'cmd': return 'primary';
          case 'data': return 'info';
          case 'info': return 'secondary';
          case 'cfg': return 'warning';
          case 'error': return 'danger';
          default: return 'light';
        }
      },

      translateHistoryType(type) {
        switch (type) {
          case 'state': return 'Estado';
          case 'cmd': return 'Comando';
          case 'data': return 'Datos';
          case 'info': return 'Información';
          case 'cfg': return 'Configuración';
          case 'error': return 'Error';
          default: return type;
        }
      }
    }
  </script>

</device-history>
